module.exports = __webpack_public_path__ + "img/4.9d07a770.png";